import { Stack, Typography } from '@mui/material';
import { CONTRACT_TYPES } from '@vy/types';
import { useWatch } from 'react-hook-form';
import { VySelectField } from '../../../../../components/design/inputs';

const contractTypeOptions = [
  { id: CONTRACT_TYPES.Standard, label: 'Standard' },
  { id: CONTRACT_TYPES.ParentAgreement, label: 'Partnership / Reseller agreement' },
];

export const ContractTypeSection: React.FC = () => {
  const selectedContractType = useWatch({ name: 'contractType' });
  const isParentAgreement = selectedContractType === CONTRACT_TYPES.ParentAgreement;
  const descriptionOpacity = isParentAgreement ? 1 : 0;

  return (
    <Stack>
      <Typography sx={{ fontSize: '12px', color: '#1B3D5599', mb: '2px' }}>Select contract type</Typography>
      <VySelectField
        name="contractType"
        options={contractTypeOptions}
        getOptionLabel={(option) => option.label as string}
        placeholder="Select contract type"
        focused={true}
      />
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontSize: '12px',
          lineHeight: '16px',
          mt: 0.5,
          opacity: descriptionOpacity,
          transition: 'opacity 0.2s ease-in-out'
        }}>
        Use when billing a reseller for multiple end customers - creates a single invoice with child usage as
        line items.
      </Typography>
    </Stack>
  );
};
